import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import DeviceStatistics from "views/admin/devices"
import UserStatistics from "views/admin/users"
import ProductCatalog from "views/admin/product"
// import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
// import DataTables from "views/admin/tables";
// import RTLDefault from "views/rtl/default";

// Auth Imports
// import SignIn from "views/auth/SignIn";

// Icon Imports
import {
    MdHome,
    // MdOutlineShoppingCart,
    // MdBarChart,
    MdPerson,
    MdLock,
    // MdDevices,
    // MdOutlineDevices,
    MdOutlineDevicesOther,
    // MdVerifiedUser,
    // MdOutlineNaturePeople,
    MdPeople,
    // MdApps,
    // MdMobileScreenShare,
    MdNewReleases, MdOutlineFeedback, MdOutlineSummarize, MdOutlineAdsClick, MdRestaurantMenu, MdDining,
    MdSwitchAccount,
} from "react-icons/md";
import SignUp from "./views/auth/SignUp";
import Verification from "./views/auth/Verification";
import ForgotPassword from "./views/auth/ForgotPassword";
import UserDetailsStatsTable from "./views/admin/users/components/UserDetailsStatsTable";
import NewProduct from "./views/admin/product/newProduct";
import SettingsProduct from "./views/admin/product/settingsProduct";
import SignInWithOtp from "./views/auth/SignInWithOtp";
// import DeleteAccountPage from "./views/auth/DeleteAccount";
import SignInV2 from "./views/auth/SignInV2";
import Feedback from "./views/admin/feedback";
import Advertising from "./views/admin/ads";
import DpConfigTable from "./views/admin/product/dpConfig/DpConfigTable";
import {BiFoodMenu} from "react-icons/bi";
import Recipe from "./views/admin/recipe";
import CreateRecipe from "./views/admin/recipe/CreateRecipe";
import BCCManager from "./views/admin/feedbackUsers";

// const routes = [
//   {
//     name: "Main Dashboard",
//     layout: "/senze-2.0/admin",
//     path: "dashboard",
//     icon: <MdHome className="h-6 w-6" />,
//     component: <MainDashboard />,
//   },
//   /*{
//     name: "NFT Marketplace",
//     layout: "/admin",
//     path: "nft-marketplace",
//     icon: <MdOutlineShoppingCart className="h-6 w-6" />,
//     component: <NFTMarketplace />,
//     secondary: true,
//   },*/
//   {
//     name: "Device Analytics",
//     layout: "/senze-2.0/admin",
//     icon: <MdOutlineDevicesOther className="h-6 w-6" />,
//     path: "device",
//     component: <DeviceStatistics />,
//   },
//   {
//     name: "User Analytics",
//     layout: "/senze-2.0/admin",
//     icon: <MdPeople className="h-6 w-6" />,
//     path: "user",
//     component: <UserStatistics />,
//   },
// /*  {
//     name: "App Analytics",
//     layout: "/senze-2.0/admin",
//     icon: <MdMobileScreenShare className="h-6 w-6" />,
//     path: "app",
//     component: <UserStatistics />,
//   },*/
//   /*{
//     name: "Data Tables",
//     layout: "/admin",
//     icon: <MdBarChart className="h-6 w-6" />,
//     path: "data-tables",
//     component: <DataTables />,
//   },*/
//   {
//     name: "Profile",
//     layout: "/senze-2.0/admin",
//     path: "profile",
//     icon: <MdPerson className="h-6 w-6" />,
//     component: <Profile />,
//   },
//   {
//     name: "Sign In",
//     layout: "/auth",
//     path: "sign-in",
//     icon: <MdLock className="h-6 w-6" />,
//     component: <SignIn />,
//   },
//
//   {
//     name: "Sign Up",
//     layout: "/auth",
//     path: "sign-up",
//     icon: <MdLock className="h-6 w-6" />,
//     component: <SignUp />,
//   },
//   {
//     name: "Reset Password",
//     layout: "/auth",
//     path: "reset-password",
//     icon: <MdLock className="h-6 w-6" />,
//     component: <ForgotPassword />,
//   },
//   {
//     name: "OTP Verification",
//     layout: "/auth",
//     path: "verify-otp",
//     icon: <MdLock className="h-6 w-6" />,
//     component: <Verification />,
//   },
//  /* {
//     name: "RTL Admin",
//     layout: "/rtl",
//     path: "rtl",
//     icon: <MdHome className="h-6 w-6" />,
//     component: <RTLDefault />,
//   },*/
// ];
const routes = [
    // --- Dashboards ---
    {
        name: "Dashboards",
        path: "/dashboard",
        icon: <MdHome className="text-inherit h-5 w-5"/>,
        collapse: true,
        items: [
            {
                name: "Main Dashboard",
                layout: "/admin",
                path: "/dashboard",
                icon: <MdHome className="text-inherit h-5 w-5"/>,
                component: <MainDashboard/>,
            },
            {
                name: "Device Analytics",
                layout: "/admin",
                icon: <MdOutlineDevicesOther className="h-6 w-6"/>,
                path: "/analytics/device",
                component: <DeviceStatistics/>,
            },
            {
                name: "User Analytics",
                layout: "/admin",
                icon: <MdPeople className="h-6 w-6"/>,
                path: "/analytics/user",
                component: <UserStatistics/>,
            },
            {
                name: "Users Overview",
                layout: "/admin",
                icon: <MdOutlineDevicesOther className="h-6 w-6"/>,
                path: "/stats/details-user",
                component: <UserDetailsStatsTable/>,
            },
            {
                name: "New Product",
                layout: "/admin",
                icon: <MdNewReleases className="h-6 w-6"/>,
                path: "/products/new-product",
                component: <NewProduct/>,
            },
            {
                name: "Products Overview",
                layout: "/admin",
                icon: <MdOutlineDevicesOther className="h-6 w-6"/>,
                path: "/products/products-overview",
                component: <ProductCatalog/>,
            },
            {
                name: "DP Config",
                layout: "/admin",
                icon: <MdOutlineDevicesOther className="h-6 w-6"/>,
                path: "/products/data-point/config",
                component: <DpConfigTable/>,
            },
            {
                name: "Feedback Overview",
                layout: "/admin",
                icon: <MdOutlineFeedback className="h-6 w-6"/>,
                path: "/feedback/feedback-overview",
                component: <Feedback/>,
            },
            {
                name: "Communication Emails",
                layout: "/admin",
                icon: <MdOutlineDevicesOther className="h-6 w-6"/>,
                path: "/feedback/bcc",
                component: <BCCManager/>,
            },
            {
                name: "Advertising Overview",
                layout: "/admin",
                icon: <MdOutlineAdsClick className="h-6 w-6"/>,
                path: "/advertising/ads-overview",
                component: <Advertising/>,
            },

            /*{
                name: "User Access",
                layout: "/senze-2.0/admin",
                icon: <MdPeople className="h-6 w-6"/>,
                path: "/users/user-access",
                component: <UserAclDetailsTable/>,
            },*/
        ]
    },
    {
        name: "Profile",
        layout: "/admin",
        path: "/profile",
        icon: <MdPerson className="h-6 w-6"/>,
        component: <Profile/>,
    },

    {
        name: "Sign In",
        layout: "/auth",
        path: "sign-in",
        icon: <MdLock className="h-6 w-6"/>,
        component: <SignInV2/>,
    },

    {
        name: "Sign Up",
        layout: "/auth",
        path: "sign-up",
        icon: <MdLock className="h-6 w-6"/>,
        component: <SignUp/>,
    },

    {
        name: "Reset Password",
        layout: "/auth",
        path: "reset-password",
        icon: <MdLock className="h-6 w-6"/>,
        component: <ForgotPassword/>,
    },

    {
        name: "OTP Verification",
        layout: "/auth",
        path: "verify-otp",
        icon: <MdLock className="h-6 w-6"/>,
        component: <Verification/>,
    },

    {
        name: "Login With OTP",
        layout: "/auth",
        path: "login-otp",
        icon: <MdLock className="h-6 w-6"/>,
        component: <SignInWithOtp/>,
    },

    {
        name: "Product Details",
        layout: "/admin",
        icon: <MdOutlineDevicesOther className="h-6 w-6"/>,
        path: "/products/product-details/:id",
        component: <SettingsProduct/>,
    },
    {
        name: "Recipe Menu",
        path: "/admin/",
        icon: <BiFoodMenu className=" h-6 w-6"/>,
        collapse: true,
        items: [
            {
                name: "Recipe",
                layout: "/admin",
                icon: <MdRestaurantMenu className="h-5 w-5"/>,
                path: "/recipe-menu",
                component: <Recipe/>,
            },
            // {
            //     name: "Recipe Creator",
            //     layout: "/admin",
            //     icon: <MdDining className="h-5 w-5"/>,
            //     path: "/recipe-create",
            //     component: <CreateRecipe />,
            // }
        ]
    },

/*    {
        name: "Delete Account",
        layout: "/auth",
        icon: <MdOutlineDevicesOther className="h-6 w-6"/>,
        path: "/delete-account",
        component: <DeleteAccountPage/>,
    },*/
    // --- NFTs ---
    // {
    // 	name: 'RTL Admin',
    // 	layout: '/rtl',
    // 	path: 'rtl-default',
    // 	// icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    // 	component: () => <MainDashboard /> RTL
    // }
];

export default routes;
